import { Skeleton } from 'antd';

export const SkeletonLoader: React.FC = () => {
  return <Skeleton title={{ width: '100%' }} paragraph={{ rows: 8 }} active loading />;
};
